import { render, staticRenderFns } from "./Co41Page.vue?vue&type=template&id=656afa36"
import script from "./Co41Page.vue?vue&type=script&lang=js"
export * from "./Co41Page.vue?vue&type=script&lang=js"
import style0 from "./Co41Page.vue?vue&type=style&index=0&id=656afa36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports